import React from 'react';
import {
	List,
	Datagrid,
	TextField,
	DateField,
	TextInput,
	Pagination as DefaultPagination
} from 'react-admin';

const CustomPagination = (props: any) => (
	<DefaultPagination rowsPerPageOptions={[25]} {...props} />
);

export const ClientList = (props: any) => (
	<List
		{...props}
		perPage={25}
		pagination={<CustomPagination />}
		filters={[
			<TextInput key='name' label='Name' source='name' alwaysOn />,
			<TextInput
				key='location'
				label='Standort'
				source='location'
				alwaysOn
			/>,
			<TextInput key='router' label='Router' source='router' alwaysOn />
		]}
	>
		<Datagrid rowClick='show' bulkActionButtons={false}>
			<TextField source='name' label='Name' />
			<TextField source='location' label='Standort' />
			<TextField source='router' label='Router' />
			<DateField source='updatedAt' showTime label='Letztes Update' />
		</Datagrid>
	</List>
);
